module.exports = __webpack_public_path__ + "img/bf.9a958401.svg";